import classNames from 'classnames';
import React from 'react';

import * as OrgActions from 'actions/OrganizationActions';
import {EntityStoreUser, Referral, ReferralStatus} from 'constants/EntityStoreConstants';
import {Organization} from 'orgs/OrganizationConstants';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import * as DateUtil from 'util/DateUtil';

interface UserAcceptedStatusProps {
  accepted: boolean;
}

function UserAcceptedStatus(props: UserAcceptedStatusProps): JSX.Element {
  return (
    <div className={classNames({faded: !props.accepted})}>
      <BenchlingIcon icon="check" className={classNames({'u-success-color': props.accepted})} />{' '}
      {props.accepted ? 'Accepted' : 'Invite Sent'}
    </div>
  );
}

interface ReferralTableProps {
  user: EntityStoreUser;
  referrals: Array<Referral>;
}

class ReferralTable extends React.Component<ReferralTableProps> {
  inviteToOrg = (orgId: string, email: string): void => {
    OrgActions.inviteUser(orgId, email);
  };

  render(): JSX.Element {
    return (
      <div className="u-large-spacing-top">
        <Row className="u-spacing-top u-small-spacing-bottom">
          <Col xs={5}>
            <strong>Email</strong>
          </Col>
          <Col md={2} className="hidden-sm hidden-xs">
            <strong>Invited</strong>
          </Col>
          <Col md={2} xs={3}>
            <strong>Status</strong>
          </Col>
          <Col md={3} xs={4}>
            <strong>Organization</strong>
          </Col>
        </Row>
        <div className="u-vertical-internal-border">
          {(() => {
            const result = [];
            for (const referral of this.props.referrals) {
              const pendingOrgIds = referral.orgStatuses
                .filter(({status}) => status === ReferralStatus.PENDING)
                .map(({organizationId}) => organizationId);
              const memberOrgIds = referral.orgStatuses
                .filter(({status}) => status === ReferralStatus.MEMBER)
                .map(({organizationId}) => organizationId);
              result.push(
                <Row key={referral.email} className="invitePage-referral">
                  <Col xs={5}>{referral.email}</Col>
                  <Col md={2} className="hidden-sm hidden-xs">
                    {DateUtil.readableTime(new Date(referral.createdAt))}
                  </Col>
                  <Col md={2} xs={3}>
                    <UserAcceptedStatus accepted={referral.user != null} />
                  </Col>
                  <Col md={3} xs={4}>
                    {this.props.user.organizations
                      .filter(({admin}) => admin)
                      .map((organization: Organization) => (
                        <div key={organization.id} className="invitePage-referrals-organization">
                          {(() => {
                            if (pendingOrgIds.includes(organization.id)) {
                              return <span className="faded">{`Invited to ${organization.name}`}</span>;
                            }
                            if (memberOrgIds.includes(organization.id)) {
                              return organization.name;
                            } else {
                              return (
                                <a onClick={this.inviteToOrg.bind(null, organization.id, referral.email)}>
                                  {`Add to ${organization.name}`}
                                </a>
                              );
                            }
                          })()}
                        </div>
                      ))}
                  </Col>
                </Row>
              );
            }
            return result;
          })()}
        </div>
      </div>
    );
  }
}

export default ReferralTable;
